// src/pages/NotificacaoAcademica/NotificacaoPage.jsx
import React from 'react';
import NotificacaoList from '../../components/NotificacaoAcademica/NotificacaoList';

const NotificacaoPage = () => {
    return (
        <div>
            <h1>Minhas Notificações</h1>
            <NotificacaoList />
        </div>
    );
};

export default NotificacaoPage;
